const localeEn = require("../locales/en.json");
const localeFr = require("../locales/fr.json");
const localeNl = require("../locales/nl.json");

const getTranslationContent = (key, locale) => {
  switch (locale) {
    case "fr":
      return localeFr[key];
    case "nl":
      return localeNl[key];
    default:
      return localeEn[key];
  }
}

const translate = (translationKey, variables) => {
  const senderLanguage = Office.context.displayLanguage;
  const baseLanguage = senderLanguage.split("-")[0];

  let translationContent = getTranslationContent(translationKey, baseLanguage);

  if (!translationContent) {
    return translationKey;
  }

  if (variables) {
    translationContent = Object.entries(variables).reduce(
      (updatedTranslationContent, [variableKey, variableValue]) => updatedTranslationContent.replace(
        new RegExp(`{{${variableKey}}}`, 'g'), variableValue
      ),
      translationContent
    );
  }

  return translationContent;
};

module.exports = translate;
